export type DeletePredefinedNoteApiResponse = unknown;
export type DeletePredefinedNoteApiArg = {
  id: string;
};
export type GetPredefinedNoteApiResponse = /** status 200  */ PredefinedNoteResponseBody;
export type GetPredefinedNoteApiArg = {
  id: string;
};
export type GetListPredefinedNoteApiResponse = /** status 200  */ PredefinedNoteListResponseBody;
export type GetListPredefinedNoteApiArg = {
  context: string;
  resourceId: string;
};
export type PostPredefinedNoteApiResponse = /** status 200  */ PredefinedNoteResponseBody;
export type PostPredefinedNoteApiArg = {
  predefinedNoteRequestBody: PredefinedNoteRequestBody;
};
export type PredefinedNoteResponseBody = {
  id: string;
  text: string;
  name: string;
  resourceId: string;
  context: string;
};
export type PredefinedNoteListResponseBody = {
  notes: PredefinedNoteResponseBody[];
};
export type PredefinedNoteRequestBody = {
  text: string;
  name: string;
  resourceId: string;
  context: string;
};
